window.portalModule = angular.module('PortalModule', []);
window.tasksModule = angular.module('TasksModule', [])

const context = require.context(".", true, /\.(js|coffee)$/i);
context.keys().forEach(function (key) {
    context(key);
});